/**
 * Online Order Form DB Service REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AdminRmaIntakeDetailsPatch { 
    batteryTypeId?: string;
    internalDropOff?: AdminRmaIntakeDetailsPatch.InternalDropOffEnum;
    externalDropOff?: AdminRmaIntakeDetailsPatch.ExternalDropOffEnum;
}
export namespace AdminRmaIntakeDetailsPatch {
    export const InternalDropOffEnum = {
        Fired: 'FIRED',
        NotFired: 'NOT_FIRED'
    } as const;
    export type InternalDropOffEnum = typeof InternalDropOffEnum[keyof typeof InternalDropOffEnum];
    export const ExternalDropOffEnum = {
        Fired: 'FIRED',
        NotFired: 'NOT_FIRED'
    } as const;
    export type ExternalDropOffEnum = typeof ExternalDropOffEnum[keyof typeof ExternalDropOffEnum];
}


export type InternalDropOffEnum = typeof AdminRmaIntakeDetailsPatch.InternalDropOffEnum[keyof typeof AdminRmaIntakeDetailsPatch.InternalDropOffEnum];
export type ExternalDropOffEnum = typeof AdminRmaIntakeDetailsPatch.ExternalDropOffEnum[keyof typeof AdminRmaIntakeDetailsPatch.ExternalDropOffEnum];
